/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum TagDomain {
  Orders="Orders",
Routes="Routes",
CustomerProfiles="CustomerProfiles"
}

/**
* TagDomain
*/
export const TagDomainEnumType = types.enumeration("TagDomain", [
        "Orders",
  "Routes",
  "CustomerProfiles",
      ])
